/* eslint-disable prettier/prettier */

export class Util {
    static getHeaderAddress(length: number) {
        return `A1:${this.getColumnLetter(length)}1`;
    }

    static getColumnLetter(columnNumber) {
        let columnName = '';
        while (columnNumber > 0) {
            const remainder = (columnNumber - 1) % 26;
            columnName = String.fromCharCode(65 + remainder) + columnName;
            columnNumber = Math.floor((columnNumber - 1) / 26);
        }
        return columnName;
    }

    static camelCase(str: string) {
        // convert PascalCase, underscore case, dash separated or title case to camelCase
        let pascal = this.pascalCase(str);
        return pascal.charAt(0).toLowerCase() + pascal.slice(1);
        // return str.split(/[\s_-]+/).map((word, index) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1)).join('');
        // return prop.charAt(0).toLowerCase() + prop.substring(1);
    }

    static titleCase(str: string) {
        str = str.replace(/([a-z])([A-Z])/g, '$1 $2');
        str = str.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');
        str = str.charAt(0).toUpperCase() + str.slice(1);
        return str;
    }

    static pascalCase(str: string) {
        // convert camelCase, underscore case, dash separated or title case to PascalCase
        return str.split(/[\s_-]+/).map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('');
    }

    static underscoreCase(str: string) {
        str = str.replace(/\./g, " ");
        str = str.replace('  ', ' ').trim();
        let res = str.split(/\.?(?=[A-Z])/).join('_').toLowerCase();
        res = res.replace(/ _/g, "_");
        res = res.replace(/ /g, '_');
        return res;
    }

    static getDate(addDays: number = 0) {
        let date = new Date();
        date.setDate(date.getDate() + addDays);
        return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    }

    static numToWords(num: number | string) {
        var a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
        var b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
        if ((num = num.toString()).length > 9) return 'overflow';
        let n: any = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
        if (!n) return; var str = '';
        str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
        str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
        str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
        str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
        str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + 'only ' : '';
        return str;
    }

    static randomString(length: number) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        return result;
    }

    static generateInvoiceNumber(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear() - 2000;

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day, 1].join('');
    }

    static getLastDateOfMonth(date) {
        const newDate = new Date(date);
        newDate.setMonth(newDate.getMonth() + 1, 1);
        newDate.setDate(newDate.getDate() - 1);
        return newDate;
    }

    static getDatabaseType(connectionString: string) {
        if (!connectionString || typeof connectionString !== "string") {
            throw new Error("Invalid");
        }

        // Convert to lowercase for case-insensitive matching
        const connStr = connectionString.toLowerCase();

        if (connStr.startsWith("postgresql://") || connStr.includes("host=") && connStr.includes("port=") && connStr.includes("dbname=")) {
            return "PostgreSQL";
        } else if (connStr.startsWith("server=") || connStr.includes("data source=")) {
            return "MSSQL";
        } else if (connStr.startsWith("mysql://") || connStr.includes("server=") && connStr.includes("database=")) {
            return "MySQL";
        } else if (connStr.startsWith("sqlite:") || connStr.endsWith(".sqlite") || connStr.endsWith(".db")) {
            return "SQLite";
        } else if (connStr.startsWith("mongodb://") || connStr.startsWith("mongodb+srv://")) {
            return "MongoDB";
        } else if (connStr.startsWith("oracle://") || connStr.includes("user id=") && connStr.includes("password=")) {
            return "Oracle";
        } else {
            return "Unknown";
        }
    }
}